import React from "react";
import { Shield } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tfl-footer" aria-label="Site Footer">
      <div className="tfl-footer__inner">
        <div className="tfl-footer__grid">
          {/* Brand Column */}
          <div>
            <a href="/" className="tfl-nav__brand">
              <div className="tfl-nav__brand-icon">
                <Shield size={16} color="#ffffff" />
              </div>
              <span>ThreatForge</span>
            </a>
            <p className="tfl-footer__desc">
              Continuous application threat modeling, dynamic attack tree simulation, and automated compliance auditing for modern DevSecOps teams.
            </p>
          </div>

          {/* Product Column */}
          <div>
            <div className="tfl-footer__col-title">Platform</div>
            <ul className="tfl-footer__links">
              <li><a href="#features">PASTA &amp; STRIDE Engine</a></li>
              <li><a href="#features">Dynamic Attack Trees</a></li>
              <li><a href="#about">About ThreatForge</a></li>
              <li><a href="#features">Collaborative Spaces</a></li>
              <li><a href="#pricing">Pricing Plans</a></li>
            </ul>
          </div>

          {/* Frameworks Column */}
          <div>
            <div className="tfl-footer__col-title">Frameworks</div>
            <ul className="tfl-footer__links">
              <li><a href="/login">STRIDE Matrix</a></li>
              <li><a href="/login">PASTA 7-Stage Process</a></li>
              <li><a href="/login">OWASP Top 10 Mapping</a></li>
              <li><a href="/login">MITRE ATT&amp;CK Integration</a></li>
              <li><a href="/login">NIST SP 800-53 Controls</a></li>
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <div className="tfl-footer__col-title">Resources</div>
            <ul className="tfl-footer__links">
              <li><a href="/login">Documentation</a></li>
              <li><a href="/login">Security Catalog</a></li>
              <li><a href="/login">Sign In</a></li>
              <li><a href="/login">System Status</a></li>
              <li><a href="/login">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="tfl-footer__bottom">
          <div>© {currentYear} ThreatForge Inc. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
